import { createSelector } from 'reselect';

import { getProgramsCategory } from './programsCategory.selectors';

export const getEligibilityBuilderSchema = createSelector(
  getProgramsCategory,
  ({ eligibilityBuilderSchema }) => eligibilityBuilderSchema,
);
